import fetch from '../config/api'
/**
 * 提交预约
 * param {p} 平台，w、wx
 */
const AppointmentSubmit = (date, phone, list = []) => {
    let json = {
        p: 'wx',
        date,
        phone,
        list
    }
    return fetch('/ticket/submit_yuyue', json, 'POST');
};

/**
 * 闭关日期列表
 * param {p} 平台，w、wx
 * 
 *"data": {
 *  "per_week_close_date": "5",
 *  "close_date_list": [
 *      "2018-11-09"
 *  ]
 *}
 */
const CloseDate = (language = '1', activity_id) => fetch('/ticket/close_date', {
    p: 'wx',
});


export default {
    AppointmentSubmit,
    CloseDate
}